var map = {
	"./7-9.png": 91841,
	"./audio.png": 32150,
	"./download.png": 60182,
	"./hskk_title.png": 5380,
	"./image.png": 80395,
	"./listen.png": 89135,
	"./microphone.png": 98778,
	"./pdf.png": 49202,
	"./ppt.png": 90156,
	"./read.png": 82590,
	"./speaking.png": 96428,
	"./syllabuses.png": 56967,
	"./time1.png": 41728,
	"./title.png": 41890,
	"./translation.png": 27221,
	"./unknown.png": 73378,
	"./video.png": 30657,
	"./warn.png": 94170,
	"./word.png": 89086,
	"./write.png": 13009,
	"./yct.png": 19304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10273;